import Sidebar from "../Sidebar/Sidebar";
import "../PracticeLayout/PracticeLayout.css";
import "./PersistentSidebarLayout.css";

const PersistentSidebarLayout = ({ children }) => {
  return (
    <div className="practice-layout persistent-sidebar-layout">
      <Sidebar />
      <div className="practice-content">{children}</div>
    </div>
  );
};

export default PersistentSidebarLayout;
